import { render, staticRenderFns } from "./customDialog.vue?vue&type=template&id=4bface15"
import script from "./customDialog.vue?vue&type=script&lang=js"
export * from "./customDialog.vue?vue&type=script&lang=js"
import style0 from "./customDialog.vue?vue&type=style&index=0&id=4bface15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports